import { useQuery } from '@hooks/reactQuery';

import { getSiteIdsBranch } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { refetchOptions } from '@constants/common';
import { MO_BRANCH_SITE_IDS } from '@constants/queryKeys';

export const useQuerySiteIdsBranch = (comparisonId: string) => {
	const {
		data: siteIdsOptions,
		isLoading: isLoadingSiteIds,
	} = useQuery({
		queryKey: [MO_BRANCH_SITE_IDS, comparisonId],
		queryFn: extractQueryParams(getSiteIdsBranch),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		...refetchOptions,
	});

	return { siteIdsOptions: siteIdsOptions || [], isLoadingSiteIds };
};
